import { Injectable } from '@angular/core';
import { Observable, filter, takeUntil } from 'rxjs';
import { WdxDestroyClass } from '../../../services/destroy';

@Injectable()
export class WdxStateManagementClass extends WdxDestroyClass {
    /**
     * Calls the dispatch function if the value of the observer is falsy
     */
    dispatchIfFalsy(observer: Observable<any>, dispatch: () => any): void {
        observer
            .pipe(
                takeUntil(this.destroyed$),
                filter((result) => !result)
            )
            .subscribe(() => dispatch());
    }
}
